export default __webpack_public_path__ + "static/media/image-previous.46afaaaf.svg";